<template>
  <div class="customer">
    <v-container class="d-flex-column">
      <template>
        <v-card :loading="loading" class="mt-5">
          <v-card-title>
            <h1 class="mr-2 subheading grey--text">Τιμολόγια</h1>
            <v-spacer></v-spacer>
            <v-container fluid>
          <v-row>
            <v-col cols="12" md="2" >
              <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Start date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                @input="menu = false"
                min="2021-11-01"
                :events="functionEvents"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
            <v-col cols="12" md="2" >
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date2"
                  label="End date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                @input="menu2 = false"
                :events="functionEvents"
                min="2021-11-01"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
            <v-col cols="12" md="3" align="center" >
              <v-combobox
                v-model="part"
                :items="parts"
                :hint="partDesc"
                persistent-hint
                item-text="Desc"
                label="Ανταλλακτικό"
                prepend-icon="mdi-engine"
                return-object
                clearable
              >
            <template v-slot:item="{ item }">
              {{ item.itemcode }}: {{ item.description }}
            </template>
            <template v-slot:selection="{ item }">
              {{ item.itemcode }}
            </template>
              </v-combobox>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="2" align="end" >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
            </v-row>
            <v-row>
              <v-col cols=4>
                 <v-file-input
                  chips
                  dense
                  prepend-icon="mdi-microsoft-excel"
                  accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  label="Πωλήσεις"
                  placeholder="Επιλέξτε αρχείο πωλήσεων"
                  v-model="salesFile"
                ></v-file-input>
              </v-col>
              <v-col>
                <v-btn @click="updateSales" icon><v-icon>mdi-update</v-icon></v-btn>
              </v-col>
            </v-row>
          <v-row>
            <v-col cols="12" md="4">
              Πίστωση: {{ pist }}
            </v-col>
            <v-col cols="12" md="4">
              Μετρητοίς: {{ metr }}
            </v-col>
            <v-col cols="12" md="4">
              Κάρτα: {{ karta }}
            </v-col>
            <v-col cols="12" md="4">
              Σύνολο: {{ total }}
            </v-col>
            </v-row>
            </v-container>
          </v-card-title>
          <v-data-table :headers="headers" :items="invoicesFiltered" :search="search"
          loading: false item-key="Id" class="elevation-1"
          :loading="loading" loading-text="Loading... Please wait"
                    :height="$vuetify.breakpoint.height*0.7"
          dense
          mobile-breakpoint=810
          single-expand: true show-group-by :expanded.sync="expanded"
          show-expand >
          <template v-slot:top>
            <v-toolbar flat>
              <v-dialog v-model="timdialog" scrollable max-width="800px">
                <v-card>
                  <v-card-title class="text-h5 grey lighten-2">
                    Line Items
                  </v-card-title>
                  <v-card-text>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">A/A</th>
                            <th class="text-center">Κωδικός</th>
                            <th class="text-left">Περιγραφή</th>
                            <th class="text-right">Ποσότητα</th>
                            <th class="text-right">Αξία</th>
                            <th class="text-right">Καθαρή Αξία</th>
                            <th class="text-right">ΦΠΑ</th>
                            <th class="text-right">Σύνολο</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="line in diaitems" :key="line.SN">
                            <td>{{ line.SN }}</td>
                            <td class="text-center">{{ line.ItmCode }}</td>
                            <td class="text-left">{{ line.description }}</td>
                            <td class="text-right">{{ line.QtyA }}</td>
                            <td class="text-right">{{ line.UnitPrice }}</td>
                            <td class="text-right">{{ line.LineNetvalue }}</td>
                            <td class="text-right">{{ line.LineVatValue }}</td>
                            <td class="text-right">
                              {{ line.LineTotalValue }}
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn icon @click.stop="showdialog(item)">
              <v-icon>mdi-information-variant</v-icon>
            </v-btn>
            <v-btn icon :to="'/invoice/details/' + item.Id">
              <v-icon>mdi-file-document</v-icon>
            </v-btn>
          </template>

          <template
            v-slot:group.header="{ group, items, isOpen, toggle, remove }"
          >
            <th colspan="10">
              <v-icon @click="toggle"
                >{{ isOpen ? "mdi-minus" : "mdi-plus" }}
              </v-icon>
              {{ group }}: {{ tocurr(sumField(items, "TotalValue")) }}
              <v-icon @click="remove">mdi-close </v-icon>
            </th>
          </template>

          <template v-slot:item.NetValue="{ item }">
            {{ tocurr(item.NetValue) }}
          </template>
          <template v-slot:item.TotalValue="{ item }">
            {{ tocurr(item.TotalValue) }}
          </template>
          <template v-slot:item.VatValue="{ item }">
            {{ tocurr(item.VatValue) }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              More info about {{ item.DocNumber }}
              <p>Παρατηρήσεις</p>
              <p>{{ item.Remarks }}</p>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">A/A</th>
                      <th class="text-left">Κωδικός</th>
                      <th class="text-left">Περιγραφή</th>
                      <th>Ποσότητα</th>
                      <th>Αξία</th>
                      <th>Καθαρή Αξία</th>
                      <th>ΦΠΑ</th>
                      <th>Σύνολο</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="line in item.line_items" :key="line.SN">
                      <td>{{ line.SN }}</td>
                      <td>{{ line.ItmCode }}</td>
                      <td>{{ line.description }}</td>
                      <td>{{ line.QtyA }}</td>
                      <td>{{ line.UnitPrice }}</td>
                      <td>{{ line.LineNetvalue }}</td>
                      <td>{{ line.LineVatValue }}</td>
                      <td>{{ line.LineTotalValue }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </td>
          </template>
          </v-data-table>
        </v-card>
      </template>
    </v-container>
  </div>
</template>

<script>
import { filter as _filter, some as _some } from 'lodash';

export default {
  computed: {
    pist () { return this.tocurr(this.sumField(this.invoices.filter(e => (e.PaymTerm.Term == 7)), 'TotalValue')); },
    karta () { return this.tocurr(this.sumField(this.invoices.filter(e => (e.PaymTerm.Term == 3)), 'TotalValue')); },
    metr () { return this.tocurr(this.sumField(this.invoices.filter(e => (e.PaymTerm.Desc == "Μετρητοίς")), 'TotalValue')); },
    total () { return this.tocurr(this.sumField(this.invoices, 'TotalValue')); },
    partDesc() {
      if (!this.part) return '';
      return this.part.Desc;
    },
    invoicesFiltered () {
      //console.log(this.part);
      if (!this.part) return this.invoices;
      return _filter(this.invoices, e => _some(e.Lines, ['ItemCode', this.part.ΙtemCode]));
    },
  },
  data() {
    return {
      menu: false,
      menu2: false,
      income: [0, 0],
      date: this.isodate(new Date(new Date().setDate(1))), // (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      date2: this.isodate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      ),
      expanded: [],
      timdialog: false,
      diaitems: {},
      loading: true,
      balance: 0.0,
      salesFile: null,
      info: {
        name: "",
        address: "",
        telephone: "",
        nino: "",
        doi: "",
        city: "",
      },
      search: "",
      customer_id: this.$route.params.id,
      invoices: [],
      parts: [],
      part: null,
      headers: [
        {
          text: "Αρ. Τιμολογίου",
          align: "start",
          //sortable: false,
          value: "InvoiceId",
          width: "10%",
          groupable: false,
        },
       // { text: 'Κατάσταση', value: 'DueDate' },
        { text: "Ημερομηνία", value: "Date", width: "10%" },
        { text: "Πελάτης", value: "Customer.Name", width: "25%" },
        { text: "Οχημα", value: "PlateNumber", width: "10%", groupable: false },
        { text: "Τρόπος πληρωμής", value: "PaymTerm.Desc", width: "10%" },
        {
          text: "Καθαρή αξία",
          value: "NetValue",
          align: "end",
          groupable: false,
        },
        { text: "ΦΠΑ", value: "VatValue", align: "end", groupable: false },
        { text: "Συνολο", value: "TotalValue", align: "end", groupable: false },
        {
          text: "Actions",
          value: "actions",
          groupable: false,
          sortable: false,
        },
        { text: "", value: "data-table-expand", groupable: false },
      ],
    };
  },
  async created() {
    if (this.$route.query.startdate) {
      this.date = this.$route.query.startdate;
    }
    if (this.$route.query.enddate) {
      this.date2 = this.$route.query.enddate;
    }
    await this.fetchdata();
    let response = await this.$api.get("/inventory/");

    this.parts = response.data;
    
  },
  watch: {
    timdialog(val) {
      val || this.close();
    },
    date() {
    if (this.date != this.$route.query.startdate){
      this.$router.replace({
        name: "Invoices",
        query: { startdate: this.date, enddate: this.date2 },
      });
      this.fetchdata();
    }
    },
    date2() {
      if (this.date2 != this.$route.query.enddate){
      this.$router.replace({
        name: "Invoices",
        query: { startdate: this.date, enddate: this.date2 },
      });
      this.fetchdata();
      }
    },
  },
  methods: {
    functionEvents (date) {
      return this.invoices.some(e => e.Date == date);
    },
    showdialog(item) {
      this.diaitems = item.line_items;
      this.timdialog = true;
    },
    close() {
      this.timdialog = false;
    },
    partText(item) {
      return item.itemcode + ": " + item.description;
    },
    async fetchdata() {
      try {
         // params: {
         //   start_date: this.date,
         //   end_date: this.date2,
         // },
        let response = await this.$api.get("/invoices/range", {
         params: {
           start_date: this.date,
           end_date: this.date2,
         },
        });
        //console.log(response);
        this.invoices = response.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    async updateSales() {
      if (this.salesFile) {
        try {
          var formData = new FormData();
          formData.append("sales_file", this.salesFile);
          let resp = await this.$api.post("/invoices/sales/upload", formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          this.salesFile = null;
          if (resp.status == 201) {
            alert("Οι πωλήσεις ενημερώθηκαν");
          } else {
            alert("Σφάλμα ενημέρωσης");
            console.log(resp);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    isodate(date) {
      return date.toISOString().substr(0, 10);
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
  },
};
</script>
